import React from 'react';
import { QuoteIcon, UserIcon } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  name: string;
  description?: string;
}
export const Testimonial = ({
  quote,
  name,
  description
}: TestimonialProps) => {
  return;
};